(function () {
    'use strict';

    angular
        .module('skillsApp')
        .directive('managerIdentitySearch', managerIdentitySearch);

    function managerIdentitySearch() {
        return {
            templateUrl: '/app/directives/manager-identity-search.tpl.html',
            scope: {
                identitySelected: '&'
            },
            controller: ManagerIdentitySearchController,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function ManagerIdentitySearchController($translate, logger, config, portalGroupService) {
        var vm = this;
        
        vm.onSelectIdentity = onSelectIdentity;
        vm.search = search;
        
        function onSelectIdentity() {
            var identity = angular.copy(vm.identity);
            if (typeof vm.identitySelected() === 'function') {
                vm.identitySelected()(identity);
            }
            vm.identity = null;
        }

        function search(find) {
            if (!find) return null;

            var searchText = find;

            vm.isLoading = true;

            return portalGroupService.getEmployeesForDepartments(config.settings.user.departmentIdsWhereManager, searchText).then(function (users) {
                vm.isLoading = false;
                return users;
            });
        }
    }
})();